// MicroWell default parameter configuration.
// The MicroWell assay uses up to 3 calibration levels (MAX_MW_LEVELS = 3),
// each with multiple ALU replicates, plus an optional MGCC curve (up to 10
// points). Math model type 0 is the standard MicroWell sigmoid model.
export const fieldConfig = [
    { label: "Assay Model Type",  name: "eAssayModelType",  default: "40" },
    { label: "MW Math Model",     name: "eMwMathModel",      default: "0" },
    { label: "SQ Cutoff A",       name: "fSQCutoff_A",       default: "0" },
    { label: "SQ Cutoff B",       name: "fSQCutoff_B",       default: "0" },
    { label: "SQ Cutoff C",       name: "fSQCutoff_C",       default: "0" },
    { label: "SQ Cutoff D",       name: "fSQCutoff_D",       default: "0" }
];

export const labelToNameMap = Object.fromEntries(
    fieldConfig.map(f => [f.label.toLowerCase(), f.name])
);

export const getLabel = (name) =>
    fieldConfig.find(f => f.name === name)?.label || name;

export const getInitialState = () => {
    const state = {};
    fieldConfig.forEach(f => (state[f.name] = f.default));
    return {
        ...state,
        // MGCC curve points stored as newline-delimited "conc,signal" pairs
        afMGCCConcentration: [],
        afMGCCSignal: [],
        TXBParse: ""
    };
};
